import axios from './index'
// 分页获取
export const getRoleList = () => {
  return axios.get('/system/role', {
    params: {
      pageNum: 1,
      pageSize: 1000
    }
  })
}
